// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

export const isSignatureModel = (signature: any): signature is SignatureModel => {
    return signature && signature.timestamp && signature.customerName && signature.customerSignature;
};
export interface SignatureData {
    timestamp: string;
    customerEmail?: string;
    customerName: string;
    customerSignature: string;
}
export interface SignatureModel extends SignatureData {
    orderNumber?: string;
}

export type SignatureState = Toolkit.Store.Bunzl.Pages.Signature.State;
export const initialSignatureState = {
    Signature: undefined,
};

export const SignatureStateActions = {
    "Store/Pages/Signature": (draft: Draft<SignatureState>, action: { action: SignatureData | undefined }) => {
        draft.Signature = action.action;
    },
};

const signatureReducer = createTypedReducerWithImmer(initialSignatureState, SignatureStateActions);
export type SignatureActions = Parameters<typeof signatureReducer>[1];

export default signatureReducer;
